import React, { Component } from 'react'
// import { storeData } from '../../../storeData'

export default class Privacidad extends Component {
  render() {
    const {storeData} = this.props
    return (
      <div className='DefaultPage'>

<h2>

Política de privacidad
</h2>

<p>

{storeData.domain} a sus aliados tecnológicos, comerciales y estratégicos autorizados, cesionarios, licenciatarios, filiales y/o subordinadas, para que, en los términos de la Ley 1581 de 2012, su Decreto Reglamentario 1377 de 2013, ley 1266 de 2008 y demás normas concordantes, le informa que los datos personales que usted suministre en virtud de las actividades, dinámicas u operaciones celebradas con la Compañía serán tratados de acuerdo a su política de Protección de Datos Personales y mediante el uso y mantenimiento de medidas de seguridad técnicas, físicas y administrativas a fin de impedir que terceros no autorizados accedan a los mismos.
</p>

<p>

Por lo que {storeData.domain} realice la recolección, compilación, almacenamiento, depuración, uso, intercambio, circulación, actualización, supresión, complementación, corrección, adición con información propia y/o de terceros autorizados y en general el tratamiento de sus Datos personales y de contacto, para que dicho tratamiento se realice con fines administrativos, comerciales, de mercadeo, para el envío de información sobre los diferentes programas y servicios, y en general para el envío de campañas, promociones o concursos de carácter comercial y publicitario, invitaciones a eventos, evaluar la calidad del servicio, realizar estudios o investigaciones de mercado, comercialización de servicios y productos a través de diferentes canales de información, gestionar tareas básicas de administración para efectos de incrementar niveles de confiabilidad y contactabilidad de los canales de comunicación utilizados, dar cumplimiento a las obligaciones contractuales y/o legales que {storeData.domain} tenga con sus aliados, clientes, empleados, proveedores, con las autoridades judiciales y administrativas, así como transferir a terceros países la información proporcionada en los términos y bajos las condiciones establecidas para tal efecto en la ley. Así como a realizar consulta, verificación o reporte de mis hábitos de pago, comportamiento e historial crediticio, financiero, comercial o divulgar ante nuestros aliados, ante cualquier central de riesgo, base de datos o cualquier otro operador de información o tercero que preste servicios a {storeData.domain}
</p>

<p>

Los invitamos a conocer la Política de Protección de Datos Personales disponibles en la página web www.{storeData.domain}, la cual incluye los procedimientos para que los titulares de datos personales puedan ejercer sus derechos a conocer, actualizar, rectificar y suprimir la información, solicitar prueba de la autorización y revocar la autorización.
</p>

<p>

Esta Política de privacidad describe cómo se recopila, utiliza y comparte su información personal cuando visita o realiza una compra en {storeData.domain} (el "Sitio").
</p>


<h2>

INFORMACIÓN PERSONAL QUE RECOPILAMOS
</h2>

<p>

Cuando visita el Sitio, recopilamos automáticamente cierta información sobre su dispositivo, incluida información sobre su navegador web, dirección IP, zona horaria y algunas de las cookies que están instaladas en su dispositivo. Además, a medida que navega por el Sitio, recopilamos información sobre las páginas web individuales o los productos que ve, qué sitios web o términos de búsqueda lo remitieron al Sitio e información sobre cómo interactúa con el Sitio. Nos referimos a esta información recopilada automáticamente como "Información del dispositivo".
</p>

<p>

Recopilamos información del dispositivo utilizando las siguientes tecnologías:
</p>

<p>

- Las "cookies" son archivos de datos que se colocan en su dispositivo o computadora y, a menudo, incluyen un identificador único anónimo. Para obtener más información sobre las cookies y cómo deshabilitarlas, visite http://www.allaboutcookies.org.
</p>

<p>

- Los "archivos de registro" rastrean las acciones que ocurren en el Sitio y recopilan datos, incluida su dirección IP, tipo de navegador, proveedor de servicios de Internet, páginas de referencia/salida y sellos de fecha/hora.
</p>

<p>

- Las "balizas web", las "etiquetas" y los "píxeles" son archivos electrónicos que se utilizan para registrar información sobre cómo navega por el Sitio.
</p>

<p>

Además, cuando realiza una compra o intenta realizar una compra a través del Sitio, recopilamos cierta información sobre usted, incluido su nombre, dirección de facturación, dirección de envío, información de pago (incluidos los números de tarjeta de crédito y pago contra entrega ), dirección de correo electrónico y número de teléfono. Nos referimos a esta información como "Información del pedido".
</p>

<p>

Cuando hablamos de "Información personal" en esta Política de privacidad, nos referimos tanto a la Información del dispositivo como a la Información del pedido.
</p>


<h2>

¿COMO USAMOS TU INFORMACIÓN PERSONAL?
</h2>

<p>

Utilizamos la Información de pedido que recopilamos generalmente para cumplir con cualquier pedido realizado a través del Sitio (incluido el procesamiento de su información de pago, la organización del envío y el suministro de facturas y/o confirmaciones de pedidos). Además, utilizamos esta información de pedido para:
Comunicarse contigo;
Revisar nuestros pedidos en busca de riesgo potencial o fraude; y
Cuando esté en línea con las preferencias que ha compartido con nosotros, proporcionarle información o publicidad relacionada con nuestros productos o servicios.
</p>

<p>

Usamos la información del dispositivo que recopilamos para ayudarnos a detectar posibles riesgos y fraudes (en particular, su dirección IP) y, en general, para mejorar y optimizar nuestro sitio (por ejemplo, al generar análisis sobre cómo nuestros clientes navegan e interactúan con el Sitio, y para evaluar el éxito de nuestras campañas de marketing y publicidad).
</p>


<h2>

COMPARTIR SU INFORMACIÓN PERSONAL
</h2>

<p>

Compartimos su información personal con terceros para ayudarnos a usar su información personal, como se describe anteriormente. Por ejemplo, usamos Shopify para impulsar nuestra tienda en línea; puede leer más sobre cómo Shopify usa su información personal aquí: https://www.shopify.com/legal/privacy. También usamos Google Analytics para ayudarnos a comprender cómo nuestros clientes usan el Sitio; puede leer más sobre cómo Google usa su información personal aquí: https://www.google.com/intl/en/policies/privacy/. También puede darse de baja de Google Analytics aquí: https://tools.google.com/dlpage/gaoptout.
</p>

<p>

Finalmente, también podemos compartir su información personal para cumplir con las leyes y regulaciones aplicables, para responder a una citación, orden de allanamiento u otra solicitud legal de información que recibamos, o para proteger nuestros derechos.
</p>


<h2>

PUBLICIDAD COMPORTAMENTAL
</h2>

<p>

Como se describió anteriormente, usamos su información personal para brindarle anuncios dirigidos o comunicaciones de marketing que creemos que pueden ser de su interés. 
</p>


<h2>

NO SEGUIR
</h2>

<p>

Tenga en cuenta que no alteramos las prácticas de uso y recopilación de datos de nuestro Sitio cuando vemos una señal de No rastrear de su navegador.
</p>

<h2>

TUS DERECHOS
</h2>

<p>

Si es residente europeo, tiene derecho a acceder a la información personal que tenemos sobre usted y a solicitar que se corrija, actualice o elimine su información personal. Si desea ejercer este derecho, comuníquese con nosotros a través de la información de contacto a continuación.
Además, si es residente europeo, notamos que estamos procesando su información para cumplir con los contratos que podríamos tener con usted (por ejemplo, si realiza un pedido a través del Sitio), o para perseguir nuestros intereses comerciales legítimos enumerados anteriormente. Además, tenga en cuenta que su información se transferirá fuera de Europa, incluidos Canadá y los Estados Unidos.
</p>


<h2>
RETENCIÓN DE DATOS
</h2>

<p>

Cuando realiza un pedido a través del Sitio, mantendremos la Información de su pedido para nuestros registros a menos y hasta que nos solicite que eliminemos esta información.
</p>

<h2>

MENORES
</h2>

<p>

El Sitio no está destinado a personas menores de 18 años.
</p>

<h2>

CAMBIOS
</h2>

<p>

Podemos actualizar esta política de privacidad de vez en cuando para reflejar, por ejemplo, cambios en nuestras prácticas o por otras razones operativas, legales o reglamentarias.
</p>

<h2>

CONTÁCTENOS
</h2>

<p>
Para obtener más información sobre nuestras prácticas de privacidad, si tiene preguntas o si desea presentar una queja, comuníquese con nosotros por correo electrónico a contacto@{storeData.domain.split("https://")[1]} o por correo utilizando los detalles que se proporcionan a continuación:
2261 Market Street #5080 San Francisco, CA 94114, USA | +1 (628) 313-4878
</p>
      </div>
    )
  }
}
